/* global SITE_URL */
import React, { Component, PropTypes } from 'react';

const fullURI = /^https?:\/\//;

export default class MobileNav extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      menuTrail: [],
      parentId: null
    };
  }

  render() {
    if (this.state.parentId) {
      return (
        <div>
          {this.renderList(
            this.props.data.find(item => item.id === this.state.parentId).children
          )}
        </div>
      );
    } else {
      return <div>{this.renderList(this.props.data)}</div>;
    }
  }

  enterLevel = item => {
    this.setState(prevState => {
      let newMenuTrail = [...prevState.menuTrail];
      newMenuTrail.push(prevState.parentId);
      return {
        menuTrail: newMenuTrail,
        parentId: item.id
      };
    });
  }

  exitLevel = () => {
    this.setState(prevState => {
      let newMenuTrail = prevState.menuTrail;
      let newParentId = newMenuTrail.pop();
      return {
        menuTrail: newMenuTrail,
        parentId: newParentId
      };
    });
  }

  renderList = itemsList => {
    let jsx = [];
    if (this.state.parentId) {
      const parent = this.props.data.filter(
        item => item.id === this.state.parentId
      )[0];
      jsx = [
        <div
          className="menu-item menu-item-parent menu-back"
          onClick={() => this.exitLevel()}
        >
          {'<  Back'}
        </div>
      ];
      if (parent.url) {
        jsx.push(
          <a
            className="menu-item-parent parent-header h3"
            key={`header-${parent.id}`}
            href={`${fullURI.test(parent.url) ? '' : SITE_URL}${parent.url}`}
          >
            {parent.name}
          </a>
        );
      } else {
        jsx.push(
          <div
            className="menu-item-parent parent-header h3"
            key={`header-${parent.id}`}
          >
            {parent.name}
          </div>
        );
      }
    }
    for (let i in itemsList) {
      const item = itemsList[i];
      if (item.parent === this.state.parentId) {
        const children = item.children;
        // "this.state.menuTrail.length" === 0 restricts the menu from going down more than a level. If we decide to have it recurse futher again, just remove that part of the condition.
        if (children && children.length > 0 && this.state.menuTrail.length === 0) {
          jsx.push(
            <div
              className="menu-item menu-item-parent"
              key={item.id}
              onClick={() => this.enterLevel(item)}
            >
              {item.name}
              <span className="expand-menu-item menu-item-parent"> {'>'} </span>
            </div>
          );
        } else {
          jsx.push(
            <a
              href={`${fullURI.test(item.url) ? '' : SITE_URL}${item.url}`}
              key={item.id}
            >
              {item.name}
            </a>
          );
        }
      }
    }
    return jsx;
  }
}
